import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_LAYER_URL,
  withCredentials: true,
});

export default axiosInstance;
